'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectUrlsByTagId = exports.selectTags = exports.setUrlsByTagId = exports.setTags = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.reducer = reducer;

var _deep = require('helpers/deep');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var key = 'features.dynamicTags';

var SET_TAGS = key + '.SET_TAGS';
var SET_URLS_BY_TAG_ID = key + '.SET_URLS_BY_TAG_ID';

var setTags = exports.setTags = function setTags(tags) {
  return { type: SET_TAGS, data: { tags: tags } };
};
var setUrlsByTagId = exports.setUrlsByTagId = function setUrlsByTagId(urlsByTagId) {
  return { type: SET_URLS_BY_TAG_ID, data: { urlsByTagId: urlsByTagId } };
};

var initialState = {
  tags: {},
  urlsByTagId: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_TAGS:
    case SET_URLS_BY_TAG_ID:
      return (0, _extends3.default)({}, state, action.data);
    default:
      return state;
  }
}

var selectTags = exports.selectTags = function selectTags(state) {
  return (0, _deep.deepExtract)(key + '.tags', state);
};
var selectUrlsByTagId = exports.selectUrlsByTagId = function selectUrlsByTagId(state) {
  return (0, _deep.deepExtract)(key + '.urlsByTagId', state);
};